import React from "react";
import { Container } from "react-bootstrap";
import { faHomeLg } from "@fortawesome/free-solid-svg-icons";
import HeaderNormal from "../components/header/HeaderNormal";
import TitleSection from "../components/heading/TitleSection";
import Footer from "../components/footer/Footer";
import { useTranslation } from "react-i18next";
import ButtonDefault from "../components/button/button-default/ButtonDefault";
import PageSeo from "../components/seo/PageSeo";
import { getPageSeo } from "../seo/siteSeo";

function NotFound() {
  const { t, i18n } = useTranslation("common");
  const seo = getPageSeo(i18n.resolvedLanguage || i18n.language, "notFound");

  return (
    <React.Fragment>
      <PageSeo
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        noindex
      />

      <HeaderNormal className="background-section text-uppercase" description={t("Page 404")}>
        {t("Erreur de page")}<br />
      </HeaderNormal>

      <Container className="section-margin">
        <TitleSection description={t("Page 404")}>
          {t("Retourner sur la page d'accueil")}
        </TitleSection>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ButtonDefault href="/" className="mt-30" text={t("Accueil")} icon={faHomeLg} />
        </div>
      </Container>

      <Footer />
    </React.Fragment>
  );
}

export default NotFound;
